var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./appstore.svg": "./src/icons/svg/appstore.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./comment-outlined.svg": "./src/icons/svg/comment-outlined.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./fa-calendar-alt.svg": "./src/icons/svg/fa-calendar-alt.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./heart-outlined.svg": "./src/icons/svg/heart-outlined.svg",
	"./home-outlined.svg": "./src/icons/svg/home-outlined.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./pi-list-checks-fill.svg": "./src/icons/svg/pi-list-checks-fill.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./question-circle-outlined.svg": "./src/icons/svg/question-circle-outlined.svg",
	"./ri-calendar-todo-line.svg": "./src/icons/svg/ri-calendar-todo-line.svg",
	"./ri-chat-3-line.svg": "./src/icons/svg/ri-chat-3-line.svg",
	"./ri-global-line.svg": "./src/icons/svg/ri-global-line.svg",
	"./ri-heart-line.svg": "./src/icons/svg/ri-heart-line.svg",
	"./ri-home-line.svg": "./src/icons/svg/ri-home-line.svg",
	"./ri-knife-line.svg": "./src/icons/svg/ri-knife-line.svg",
	"./ri-logout-box-r-line.svg": "./src/icons/svg/ri-logout-box-r-line.svg",
	"./ri-question-line.svg": "./src/icons/svg/ri-question-line.svg",
	"./ri-shopping-basket-line.svg": "./src/icons/svg/ri-shopping-basket-line.svg",
	"./ri-shopping-cart-line.svg": "./src/icons/svg/ri-shopping-cart-line.svg",
	"./ri-user-3-line.svg": "./src/icons/svg/ri-user-3-line.svg",
	"./ri-user-add-line.svg": "./src/icons/svg/ri-user-add-line.svg",
	"./ri-whatsapp-line.svg": "./src/icons/svg/ri-whatsapp-line.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./setting-outlined.svg": "./src/icons/svg/setting-outlined.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./tb-calendar-check.svg": "./src/icons/svg/tb-calendar-check.svg",
	"./tb-chef-hat.svg": "./src/icons/svg/tb-chef-hat.svg",
	"./tb-message-circle.svg": "./src/icons/svg/tb-message-circle.svg",
	"./tb-shopping-cart.svg": "./src/icons/svg/tb-shopping-cart.svg",
	"./tb-user-circle.svg": "./src/icons/svg/tb-user-circle.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user-outlined.svg": "./src/icons/svg/user-outlined.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./video-camera-add-outlined.svg": "./src/icons/svg/video-camera-add-outlined.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";